import { styled, css } from 'styled-components';
const GridContainer = styled.div.withConfig({
  componentId: "aui__sc-1g0q0g6-0"
})(["display:grid;gap:", ";& > li{display:flex;box-sizing:border-box;& > *{width:100%;height:auto;}}", " ", ";", " ", ""], ({
  $gap
}) => $gap, ({
  $autoFit,
  $columns,
  $gap
}) => $autoFit && css(["& > *:only-child{width:100%;max-width:calc((100% - ", " * ", ") / ", ");}"], $columns - 1, $gap, $columns), ({
  $minWidth,
  $columns,
  $autoFit
}) => css(["grid-template-columns:repeat( ", ",minmax(", "rem,1fr) );"], $autoFit ? 'auto-fit' : $columns, $minWidth), ({
  $maxRows,
  $columns,
  $scroll
}) => $maxRows && !$scroll && css(["& > *:nth-child(n + ", "){display:none;}"], $columns * $maxRows + 1), ({
  $scroll,
  $minWidth,
  $columns,
  $gap,
  $maxRows
}) => $scroll && css(["&&&{scroll-behavior:smooth;overflow-x:scroll;scroll-snap-type:x mandatory;grid-auto-flow:column;-webkit-overflow-scrolling:touch;& > *:focus,& > li > *:focus{outline-offset:-2px;}", " grid-template-columns:unset;grid-template-rows:repeat(", ",max-content);grid-auto-columns:max( calc( (100% - ", " * ", ") / ", " ),", "rem );}&&& > *{scroll-snap-align:", ";}&&& > *:first-child{scroll-snap-align:start;}&&& > *:last-child{scroll-snap-align:end;}"], $scroll.hideScrollbar && css(["scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;height:0;background:transparent;}"]), $maxRows || 1, $columns + $scroll.scrollHint - 1, $gap, $columns + $scroll.scrollHint, $minWidth, $scroll.scrollSnapAlign || 'start'));
export default GridContainer;